module.exports = __webpack_public_path__ + "img/notebook.ae158154.svg";